import './App.css';
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import Skill from './components/Skill/Skill';
import About from './components/About/About';
import Education from './components/Education/Education';
import Experience from './components/Experience/Experience';
import AllProjects from './components/HomeProjects/AllProjects';
import { Route, Switch } from 'react-router-dom';
import Contact from './components/Contact/Contact';
import Blogs from './components/Blogs/Blogs';
import SingleProjectDetails from './components/ProjectDetails/SingleProjectDetails';
import AOS from "aos";
import "aos/dist/aos.css";
import Loader from "react-loader-spinner";
import React, { useState, useEffect } from 'react';
function App() {
     const [loader, setLoader] = useState(false);

     useEffect(()=>{
    setLoader(true);
    setTimeout(()=>{
      setLoader(false)
    }, 3000)
  },[])

     useEffect(() => {
        AOS.init({
            duration: 1200,
             once:true
          })
          
    })
  return (
    <div className="App">
    {
        loader? <Loader className='d-flex justify-content-center' type="Bars" color="#00BFFF" height={100} width={100} timeout={3000}/>
        : <>
           <Header> </Header>
      <Switch>
        <Route exact path='/'>
             <Home> </Home>
        </Route>  
        <Route exact path='/home'>
             <Home> </Home>
        </Route>  
        <Route exact path='/skill'>
             <Skill> </Skill>
        </Route>  
        <Route exact path='/about'>
             <About> </About>
        </Route>  
        <Route exact path='/education'>
             <Education> </Education>
        </Route>  
        <Route exact path='/experience'>
             <Experience> </Experience>
        </Route>  
        <Route exact path='/projects'>
             <AllProjects> </AllProjects>
        </Route>  
        <Route exact path='/blogs'>
             <Blogs> </Blogs>
        </Route>  
        <Route exact path='/contact'>
             <Contact> </Contact>
        </Route>  
        <Route exact path='/project/:id'>
          <SingleProjectDetails> </SingleProjectDetails>
        </Route>
       </Switch>
       </>
       }
    </div>
  );
}

export default App;
